import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Button, Divider, message, Space, Modal } from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { AuthContext } from "../../../contexts/AuthContext";
import http from "../../../services/http";

export const PoliticaPrivacidadeConfirmacaoLogin = () => {
  const [loading, setLoading] = useState();
  const { session, atualizarPoliticaPrivacidade, encerrarSessao } = useContext(AuthContext);
  const [modal, contextHolder] = Modal.useModal();

  // DADOS
  const [dados, setDados] = useState([]);

  useEffect(() => {
    if (session.politicas_privacidade_pendentes.length > 0) {
      carregarPoliticaPrivacidade(session.politicas_privacidade_pendentes[0]);
    }
  }, [session.politicas_privacidade_pendentes]);

  const realizarLogout = async () => {
    await http("get", "v1/autenticacao/logout", []);
    message.success("Logout realizado com sucesso!");
    await encerrarSessao();
  };

  // CARREGAR
  const carregarPoliticaPrivacidade = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/politica_privacidade/carregar_confirmacao/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        atualizarPoliticaPrivacidade(session.politicas_privacidade_pendentes.filter((e) => e !== id));
      }
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarPoliticaPrivacidade = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/politica_privacidade_confirmacao/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Política de privacidade confirmada com sucesso!");
      if (session.politicas_privacidade_pendentes.length > 0) {
        atualizarPoliticaPrivacidade(
          session.politicas_privacidade_pendentes.filter((e) => e !== formulario.id_cad_politica_privacidade)
        );
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmit = () => {
    let values = { id_cad_politica_privacidade: dados.id };

    // ENVIAR CONFIRMAÇÃO
    salvarPoliticaPrivacidade(values);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
        <HeaderPage backText="Sair" title="Configurações" onClickBack={realizarLogout} />
        <HeaderTitle
          title="Política de Privacidade"
          subtitle={dados?.descricao}
          icon={<FileDoneOutlined />}
          loading={loading}
        />
        <Divider />

        <Card bordered={false} bodyStyle={{ padding: "3%" }}>
          <Space direction="vertical" size={20} style={{ width: "100%" }}>
            <iframe
              style={{ width: "100%", border: 0, overflow: "hidden", height: 500 }}
              src={dados?.link}
              title="Política de Privacidade"
            />
            <Button
              size="large"
              onClick={() =>
                modal.confirm({
                  title: "Você concorda com a política de privacidade?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    onSubmit();
                  },
                })
              }
              type="primary"
              loading={loading}>
              Confirmar
            </Button>
          </Space>
        </Card>
      </Col>
      {contextHolder}
    </Row>
  );
};
